import React from 'react'
import { FormControlLabel } from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'

export default ({ input, meta: { touched, error, warning }, ...rest }) => (
  <div className="form-group-mui">
    <FormControlLabel control={<Checkbox {...input} {...rest} value="on" />} {...rest} />
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/custom_check_box.js